// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2bV7y","info":"PatientInfo_info__3ozMV"};